import type { CustomCellRendererProps } from "ag-grid-react";
import { clsx } from "clsx";

import style from "../styles/Cell.module.css";
import { extractValueAsArray } from "../utils/tables.ts";
import { LinkExternalCell } from "./LinkExternalCell.tsx";
import { TruncateLinkList } from "./TruncateLinkList.tsx";

export const LinkExternalListCell = (props: CustomCellRendererProps) => {
  const values = extractValueAsArray(props.value);

  if (values.length === 1) {
    return <LinkExternalCell {...props} value={values[0]} />;
  }

  const items = values.map((value, index) => {
    const { label, link } = value ?? {};
    return {
      key: `${String(label ?? "")}-${index}`,
      label: String(label ?? ""),
      to: String(link ?? ""),
      target: "_blank",
      rel: "noopener noreferrer",
    };
  });

  const fullText = items.map((item) => item.label).join(", ");

  return (
    <div className={clsx(style.cell, style.truncate_container)}>
      <span className={style.truncate_autosize} aria-hidden>{fullText}</span>
      <TruncateLinkList items={items} className={style.truncate_content} />
    </div>
  );
};
